import { useState, useEffect } from "react";
import axios from "axios";
import Banner from "./threeDAds";

const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
};

const BannerList = ({ chunkSize = 3 }) => {
    const [ads, setAds] = useState([]);

    useEffect(() => {
        axios.get("/api/ads/all")
            .then((response) => {
                setAds(response.data);
            })
            .catch((error) => {
                console.error("Error fetching ads:", error);
            });
    }, []);

    // Filter out ads without images
    const adsWithImages = ads.filter((ad) => {
        if (!ad.images) return false;
        if (Array.isArray(ad.images)) {
            return ad.images.length > 0 && ad.images[0];
        }
        return ad.images;
    });

    const chunks = chunkArray(adsWithImages, chunkSize);

    // Don't render anything if there are no ads with images
    if (chunks.length === 0) {
        return null;
    }

    return (
        <div>
            {chunks.map((adPair, index) => (
                <div className="banner-section" key={index}>
                    <Banner ads={adPair} />
                </div>
            ))}
        </div>
    );
};

export default BannerList;
